export default __webpack_public_path__ + "static/media/icon-youtube.77ed67cb.svg";